import {PromiseResolver, PromiseRejecter} from "../lib/types"
import * as $ from "jquery"
import * as Immutable from "immutable"

export interface Result {
	Errors: string
	RedirectUrl: string
	Is3DSecure: boolean
	AccessCode: string
}

export interface Options {
	autoRedirect: boolean
	onComplete?: (data:Result) => void
	onError?: (e:any) => void
	onTimeout?: (e:any) => void
}

interface Eway {
	process: (form:HTMLFormElement, options:Options) => void
}

export class EwayError extends Error {
	//noinspection JSUnusedLocalSymbols
	constructor(public ewayResult:Result, message?:string) {
		super(message)
	}
}

interface EwayWindow extends Window {
	eWAY: Eway
}

declare var window:EwayWindow

/**
 * The eWay library needs to be downloaded directly from ewaypayments.com, so instead of holding the library directly,
 * we hold a promise of it.
 */
const eWay:PromiseLike<Eway> = new Promise<Eway>((resolve:PromiseResolver<Eway>, reject:PromiseRejecter<{}>) => {
	$.getScript("https://api.ewaypayments.com/JSONP/v3/js")
		.done(() => {
			// The loaded script attaches itself to the global variable "eWAY".
			// Grab it, delete it (so the global state is unchanged), and return it.
			var global = window.eWAY
			delete window.eWAY
			resolve(global)
		})
		.fail((jqxhr:{}, settings:{}, exception:Error) => {
			reject(exception)
		})
})

type PaymentDetails = {
	Name: string
	Number: string
	Month: string
	Year: string
	CVV: string
	FormActionURL: string
	AccessCode: string
}

function convertParamsToForm(paymentDetails:PaymentDetails):HTMLFormElement {
	const form         = document.createElement("form")
	form.style.display = 'none'
	form.method        = 'POST'
	form.action        = paymentDetails.FormActionURL

	function addField(name:string, value:string):void {
		const input = document.createElement('input')
		input.type  = "hidden"
		input.name  = name;
		input.value = value;
		form.appendChild(input);
	}

	addField("EWAY_ACCESSCODE", paymentDetails.AccessCode)
	addField("EWAY_PAYMENTTYPE", "Credit Card")
	addField("EWAY_CARDNAME", paymentDetails.Name)
	addField("EWAY_CARDNUMBER", paymentDetails.Number)
	addField("EWAY_CARDEXPIRYMONTH", paymentDetails.Month)
	addField("EWAY_CARDEXPIRYYEAR", paymentDetails.Year)
	addField("EWAY_CARDCVN", paymentDetails.CVV)

	return form
}

const ErrorCodes = Immutable.Map({
	'V6100': 'Invalid cardholder name',
	'V6101': 'Invalid card expiry month',
	'V6102': 'Invalid card expiry year',
	'V6103': 'Invalid card start month',
	'V6104': 'Invalid card start year',
	'V6105': 'Invalid card issue number',
	'V6106': 'Invalid card CCV/CVN',
	'V6110': 'Invalid card number',
})

export function processEway(params:PaymentDetails):Promise<Result> {
	return new Promise<Result>((resolve:PromiseResolver<Result>, reject:PromiseRejecter<string>) => {
		eWay.then((eWAY:Eway) => {
			const form = convertParamsToForm(params);

			eWAY.process(form, {
				autoRedirect: false,
				onComplete: (result:Result) => {
					if (result.Errors !== null && ErrorCodes.has(result.Errors)) {
						reject(ErrorCodes.get(result.Errors))
					} else {
						resolve(result)
					}
				},
				onError: (e) => resolve({
					Errors: e.hasOwnProperty('Errors') ? e.Errors : "Some error",
					RedirectUrl: params.FormActionURL,
					Is3DSecure: false,
					AccessCode: params.AccessCode
				}),
				onTimeout: () => resolve({
					Errors: "Timeout",
					RedirectUrl: params.FormActionURL,
					Is3DSecure: false,
					AccessCode: params.AccessCode
				})
			})
		})
	})
}




// WEBPACK FOOTER //
// ./src/paymentgateway/eway-external.ts